export default {"src":"/_next/static/media/SA_flag.c8e3c389.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};